<template>
  <div id="access-denied" class="access-denied-screen">
    <div class="access-denied-card">
      <div class="access-denied-icon">🔒</div>
      <div class="access-denied-title">Akses Ditolak</div>
      <div class="access-denied-message">{{ message }}</div>
      <div class="access-denied-hint">
        Hubungi administrator untuk mendapatkan link akses yang valid.
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  message: {
    type: String,
    default: 'Token tidak valid atau sudah kedaluwarsa.',
  },
})
</script>

<style scoped>
.access-denied-screen {
  position: fixed;
  inset: 0;
  background: #0d0d0d;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.access-denied-card {
  background: #141414;
  border: 1px solid #2a2a2a;
  border-radius: 12px;
  padding: 48px 40px;
  text-align: center;
  max-width: 400px;
  width: 90%;
}

.access-denied-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.access-denied-title {
  font-size: 22px;
  font-weight: 700;
  color: #f1f1f1;
  margin-bottom: 12px;
}

.access-denied-message {
  font-size: 14px;
  color: #ef4444;
  background: #ef444415;
  border: 1px solid #ef444430;
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 16px;
  line-height: 1.5;
}

.access-denied-hint {
  font-size: 12px;
  color: #555;
  line-height: 1.5;
}

@media (max-width: 480px) {
  .access-denied-card {
    padding: 32px 20px;
    max-width: 92%;
  }
  .access-denied-icon {
    font-size: 40px;
  }
  .access-denied-title {
    font-size: 18px;
  }
}
</style>
